// Anchors a native [popover] panel to its trigger button. The popover renders
// in the browser's top layer, so the results table's overflow container cannot
// clip it; light dismiss (outside click / Escape) comes from the platform.
// Positioning is done on open: below the trigger, flipped above when there is
// not enough room, always clamped to the viewport.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "panel"]

    connect() {
        this._onToggle = this.reposition.bind(this)
        this.panelTarget.addEventListener("toggle", this._onToggle)
    }

    // The panel can already be gone when the controller disconnects (the
    // element lost its data-controller after the panel left the DOM).
    disconnect() {
        if (this.hasPanelTarget) this.panelTarget.removeEventListener("toggle", this._onToggle)
    }

    reposition(event) {
        if (event.newState !== "open") return

        const margin = 8
        const trigger = this.buttonTarget.getBoundingClientRect()
        const panel = this.panelTarget

        // Neutralize the UA's centering styles (inset: 0 + margin: auto).
        panel.style.margin = "0"
        panel.style.right = "auto"
        panel.style.bottom = "auto"

        // The visible area, not window.inner*: those include the scrollbar, so a panel
        // opened from a trigger at the right edge slid under it. The courses layout
        // scrolls <body>, not the document, hence the body's width too.
        const viewportWidth = Math.min(document.documentElement.clientWidth, document.body.clientWidth)
        const viewportHeight = document.documentElement.clientHeight

        let left = Math.max(margin, Math.min(trigger.left, viewportWidth - panel.offsetWidth - margin))
        let top = trigger.bottom + margin
        if (top + panel.offsetHeight > viewportHeight - margin) {
            top = Math.max(margin, trigger.top - panel.offsetHeight - margin)
        }
        // A panel opened from elsewhere (popovertarget on another button) while its
        // trigger is scrolled out of view: keep it on screen.
        top = Math.max(margin, top)

        panel.style.left = `${left}px`
        panel.style.top = `${top}px`
    }
}
